import React, { useState } from "react";
import { object, func, string } from "prop-types";
import { chunk } from "lodash";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../../atoms/headline";
import Twitter from "../../atoms/icons/social-share/twitter";
import LoadMore from "../../atoms/loadmore";
import AuthorDefaultLogo from "../../atoms/icons/author";
import TwelveStoryMixedDesign from "../../rows/twelve-story-mixed-design";

import { setLoading } from "../../helper/actions";
import { getAuthorStories } from "../../helper/api";
import translate from "../../translate";

import "./author.m.css";

const NO_OF_ITEMS_LOAD = 12;

const AuthorPageBase = ({ data, setLoading, publisherName }) => {
  const { author } = data;

  const [stories, setStories] = useState(data.stories);
  const [offset, setOffset] = useState(data.stories.length);

  const authorImg = author["avatar-url"] || author["avatar-s3-key"];
  const twittlerHandle = author["twitter-handle"] || null;
  const authorMetadata = author.metadata || {};

  // Load More stories
  const onLoadMoreStories = () => {
    setLoading(true);

    getAuthorStories(author.id, offset, NO_OF_ITEMS_LOAD)
      .then((results) => {
        const updatedResults = [].concat(stories, results);

        setOffset(updatedResults.length); // Keep next offset ready
        setStories(updatedResults);
      })
      .finally(() => setLoading(false));
  };

  const getStoriesView = () => {
    const list = chunk(stories, 12);
    const isMoreStories = data.totalCount > stories.length;

    return (
      <React.Fragment>
        <div styleName="story-list">
          {list.map((itemList, index) => (
            <TwelveStoryMixedDesign
              key={index}
              list={itemList}
              className={isMoreStories && index + 1 === list.length ? "twelve-story-mixed-design" : ""}
            />
          ))}
        </div>

        {isMoreStories && <LoadMore onClick={onLoadMoreStories} content={translate(publisherName, "load_more")} />}
      </React.Fragment>
    );
  };

  const getAuthorView = () => (
    <div styleName="author">
      <div styleName="author-img-wrapper">
        {authorImg ? (
          <img styleName="author-img" src={authorImg} alt={author.name} />
        ) : (
          <AuthorDefaultLogo width={200} height={190} />
        )}
      </div>

      <div styleName="author-content">
        <div styleName="author-title-twitter">
          <Headline text={author.name} headerType={1} />
          {twittlerHandle && (
            <a href={`https://twitter.com/${twittlerHandle}`} target="_blank" styleName="twitter-link" rel="nofollow">
              <Twitter />
            </a>
          )}
        </div>

        {author.bio && <div styleName="author-bio" dangerouslySetInnerHTML={{ __html: author.bio }} />}
        {authorMetadata.Designation && <Headline text={authorMetadata.Designation} headerType={10} />}
        {authorMetadata.Description && <Headline text={authorMetadata.Description} headerType={11} />}
      </div>
    </div>
  );

  return (
    <div styleName="wrapper" className="container">
      {getAuthorView()}

      {data.stories.length ? getStoriesView() : <div styleName="no-stories">No stories found !!</div>}
    </div>
  );
};

AuthorPageBase.propTypes = {
  data: object,
  setLoading: func,
  publisherName: string,
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
});

const mapDispatchToProps = (dispatch) => ({
  setLoading: (isLoading) => dispatch(setLoading(isLoading)),
});

const AuthorPage = connect(mapStateToProps, mapDispatchToProps)(AuthorPageBase);

export { AuthorPage };
